import { IAgendaItem } from '@common/models/CMS/Agenda';
import Divider from '@components/general/Divider';
import { IViewport } from '@config/appConfig';
import { Culture } from '@core/Culture';
import { IAppState } from '@misc/State';
import Config from '@service/Config';
import Translate from '@service/Translate';
import { miliSecondToMinHour } from '@utilize/Format';
import { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import LargeViewTopicsItem from './LargeViewTopicsItem';
import SmallViewTopicsItem from './SmallViewTopicsItem';

export interface IAgendaTopicProps {
    dataSource?: IAgendaItem[];
    loading?: boolean;
}

export interface ITopicItem {
    rangeOfTopic?: string;
    durationTime?: string;
    displayText?: string;
    presenter?: string;
    locale?: string;
    loading?: boolean;
    first?: boolean;
    last?: boolean;
}

const AgendaTopic: FC<IAgendaTopicProps> = ({ dataSource, loading }) => {
    const { tr } = Translate;
    const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth }));
    const { small } = Config.get<IViewport>("viewport");
    const locale = useRef(Culture.getLocale().code).current;

    const configPropsItem = (data: IAgendaItem): ITopicItem => {
        const rangeOfTopic = `${new Date(data.startTime || 0).toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: false })} - ${new Date(data.endTime || 0).toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: false })}`;
        const durationTime = miliSecondToMinHour(new Date(data.endTime || 0).getTime() - new Date(data.startTime || 0).getTime());
        const displayText = data.displayText;
        const presenter = data.presenter;
        return {
            rangeOfTopic, durationTime, displayText, presenter
        }
    }

    return (
        dataSource?.length ?
            <div className="data-container flex panel">
                <div className="item-header row-item flex row desktop">
                    <h3 className="col-1-6 cell">{tr("agenda_date")}</h3>
                    <h3 className="col-1-7 cell">{tr("duration_time")}</h3>
                    <h3 className="col-1-5 flex-grow cell">{tr("comment")}</h3>
                    <h3 className="col-1-5 cell">{tr("presenter")}</h3>
                </div>
                <Divider
                    mode="default"
                    orientation="horizontal"
                    className="desktop"
                />
                {dataSource?.map((data, index) => width > small ?
                    <LargeViewTopicsItem
                        key={`large_view_topic_item_${index}`}
                        {...configPropsItem(data)}
                        loading={loading}
                        first={index === 0 ? true : false}
                        last={index === dataSource.length - 1 ? true : false}
                    />
                    :
                    <SmallViewTopicsItem
                        key={`small_view_topic_item_${index}`}
                        {...configPropsItem(data)}
                        loading={loading}
                        first={index === 0 ? true : false}
                        last={index === dataSource.length - 1 ? true : false}
                    />
                )}
            </div> : <div className="data-container panel alert">{tr("no_record")}</div>
    );
}

export default AgendaTopic
